import styled from "styled-components";

export const CMTracksPerformance = styled.div(props => ({
    backgroundColor: '#F8F8F8',
    padding: '40px 0 0',

    '& h4': {
        marginBottom: '1rem'
    }
}));

export const CMTracksContainer = styled.div(props => ({
    width: '30%',
    paddingLeft: '2rem',

    '& > div': {
        maxHeight: '390px',
        overflow: 'auto'
    }
}));

export const CMTrackChart = styled.div(props => ({
    width: '70%',

    '&.full-width': {
        width: '100%'
    },

    '& .highcharts-button': {
        borderRadius: 8,

        '&.highcharts-button-pressed': {
            '& rect': {
                fill: '#3475f4',
            },
            '& text': {
                color: 'white !important',
                fill: 'white !important'
            }
        }
    }
}));

export const CMTrackItem = styled.div(props => ({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '6px',
    padding: '14px 12px',
    backgroundColor: props.color,
    marginTop: '5px',
    color: '#fafcfd',

    '& h5': {
        fontSize: '14px',
    },

    '& span': {
        color: 'rgba(250,252,253,.8)',
        fontSize: props.theme.fontSizes.caption
    }
}));

export const CMTrackChartContainer = styled.div(props => ({
    display: 'flex',
    padding: '2rem 1rem',
    backgroundColor: 'white'
}));